import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "header-column-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 16C2.25 19.1756 4.82436 21.75 8 21.75L16 21.75C19.1756 21.75 21.75 19.1756 21.75 16L21.75 8C21.75 4.82436 19.1756 2.25 16 2.25L8 2.25C4.82436 2.25 2.25 4.82436 2.25 8L2.25 16ZM7.25 20.184C5.26049 19.8298 3.75 18.0913 3.75 16L3.75 8C3.75 5.9087 5.26049 4.1702 7.25 3.81597L7.25 20.184ZM8.75 20.25L16 20.25C18.3472 20.25 20.25 18.3472 20.25 16L20.25 8C20.25 5.65279 18.3472 3.75 16 3.75L8.75 3.75L8.75 20.25Z"
    }, null, -1)
  ])))
}
export default { render: render }